<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>{{ getDialogTitle() }}</span>
  <button mat-icon-button (click)="onCancel()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="alert alert-danger alert-dismissible fade show" *ngIf="errorMessage" role="alert">
    <mat-icon>error</mat-icon>
    <span class="ms-2">{{ errorMessage }}</span>
    <button type="button" class="btn-close" aria-label="Close" (click)="clearError()"></button>
  </div>

  <form [formGroup]="staffForm" class="staff-form">
    <!-- Selector de empleado (solo en modo creación) -->
    <div class="row" *ngIf="!isEditMode">
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Empleado</mat-label>
          <mat-select formControlName="employeeId" 
                      (selectionChange)="onEmployeeSelected($event.value)"
                      required>
            <mat-option *ngFor="let employee of employees; trackBy: trackByIndex" [value]="employee.id">
              {{ employee.display }}
            </mat-option>
          </mat-select>
          <mat-hint>Seleccione el empleado a agregar al personal</mat-hint>
          <mat-error *ngIf="staffForm.get('employeeId')?.hasError('required')">
            Debe seleccionar un empleado
          </mat-error>
        </mat-form-field>
        <div *ngIf="isLoadingEmployees" class="text-center my-2">
          <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
          <small class="text-muted d-block mt-2">Cargando empleados...</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre para mostrar</mat-label>
          <input matInput formControlName="displayName" placeholder="Ej: Juan García" required>
          <mat-hint>Este nombre se mostrará en el calendario y reservas</mat-hint>
          <mat-error *ngIf="staffForm.get('displayName')?.hasError('required')">
            El nombre para mostrar es obligatorio
          </mat-error>
          <mat-error *ngIf="staffForm.get('displayName')?.hasError('maxlength')">
            Máximo 200 caracteres
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Estado</mat-label>
          <mat-select formControlName="statusMerchantStaffId" required>
            <mat-option *ngFor="let status of data.staffStatuses; trackBy: trackByIndex" [value]="status.statusMerchantStaffId">
              {{ status.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="staffForm.get('statusMerchantStaffId')?.hasError('required')">
            El estado es obligatorio
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <label class="form-label">Color del calendario</label>
        <div class="color-picker">
          <div class="color-option" 
               *ngFor="let color of colorPresets; trackBy: trackByIndex"
               [style.background-color]="color"
               [class.selected]="staffForm.get('calendarColor')?.value === color"
               (click)="selectColor(color)">
          </div>
          <div class="color-option custom-color">
            <input type="color" 
                   formControlName="calendarColor"
                   title="Seleccionar color personalizado">
          </div>
        </div>
        <small class="text-muted">Este color se usará para identificar al personal en el calendario</small>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="isSaving">
    Cancelar
  </button>
  <button mat-raised-button class="factuone-button" (click)="onSubmit()" [disabled]="isSaving || staffForm.invalid">
    <div class="cf-dlg-loading__dots" *ngIf="isSaving"><span></span><span></span><span></span></div>
    <span *ngIf="!isSaving">{{ isEditMode ? 'Actualizar' : 'Crear' }}</span>
  </button>
</mat-dialog-actions>
